import { render, staticRenderFns } from "./StockCorrectionStoreInItems.vue?vue&type=template&id=71306976&scoped=true&"
import script from "./StockCorrectionStoreInItems.vue?vue&type=script&lang=ts&"
export * from "./StockCorrectionStoreInItems.vue?vue&type=script&lang=ts&"
import style0 from "./StockCorrectionStoreInItems.vue?vue&type=style&index=0&id=71306976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71306976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
